import { render, staticRenderFns } from "./PartnershipTypeCreate.vue?vue&type=template&id=877eb68a&scoped=true&"
import script from "./PartnershipTypeCreate.vue?vue&type=script&lang=js&"
export * from "./PartnershipTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipTypeCreate.vue?vue&type=style&index=0&id=877eb68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877eb68a",
  null
  
)

export default component.exports